import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setTokenGetter } from "./utils/authToken";

export default function Auth0AxiosBridge() {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      setTokenGetter(null);
      return;
    }


    setTokenGetter(() =>
      getAccessTokenSilently({
        authorizationParams: {
          audience: 'https://someet-api',
        },
      })
    );

    return () => setTokenGetter(null);
  }, [isAuthenticated, getAccessTokenSilently]);

  return null;
}
